<template>
  <div class="metric-tile">
    <span class="metric-tile__label">
      <slot name="label">{{ label }}</slot>
    </span>
    <span class="metric-tile__value">{{ value }}</span>
    <span class="metric-tile__caption" v-if="caption">{{ caption }}</span>
  </div>
</template>

<script>
export default {
  name: "MetricTile",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: "—"
    },
    caption: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.metric-tile {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 16px 18px;
  height: 100%;
  box-sizing: border-box;
}
.metric-tile__label {
  font-size: 13px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 4px;
}
.metric-tile__value {
  font-size: 26px;
  font-weight: 600;
  color: #003448;
  margin-top: 6px;
  line-height: 1.2;
}
.metric-tile__caption {
  font-size: 12px;
  color: #b0b3b8;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLog/MetricTile.vue